<template>
  <div style="height: 100%">
    <div class="role-field-content">
      <el-row class="field-row field-row-header">
        <el-col :span="6">字段名称</el-col>
        <el-col :span="6">权限</el-col>
        <el-col :span="12">备注</el-col>
      </el-row>
      <el-row class="field-row" style="padding-top: 10px;font-size: 12px">
        <el-col :span="6">成本</el-col>
        <el-col :span="6">
          <el-radio :disabled="roleId === '100'" v-model="radio" :label="0">不可见</el-radio>
          <el-radio :disabled="roleId === '100'" v-model="radio" :label="1">可见</el-radio>
        </el-col>
        <el-col :span="12">勾选“不可见”后全局不可见此字段，在利润计算时不会减去成本数据；</el-col>
      </el-row>
      <el-row style="padding-top: 10px;">
        <gj-button
          type="primary"
          @click="upFields"
          v-if="$permission('role:saveFields')"
          :disabled="roleId === '100'"
        >
          保存
        </gj-button>
      </el-row>
    </div>
  </div>
</template>

<script>
    import {queryRoleFields,saveRoleFields} from '../../../../../api/setting';
    export default {
        name: "app-role-field-auth",
        props: ['roleId'],
        watch:{
          roleId: {
            deep: true,  // 深度监听
            handler(newVal,oldVal) {
              this.querydata();
            }
          }
        },
        created() {
            this.querydata();
        },
        data() {
            return {
                radio: 0,
                resourceId: null
            }
        },
        methods:{
            upFields(){
              this.loading = true;
                const params = {
                  roleId: this.roleId,
                  resources: []
                };
                if(this.radio === 1){
                  params.resources.push(this.resourceId)
                }
                saveRoleFields(params).then(response => {
                  if(response.isSuccess){
                    this.querydata();
                    this.$message.success("操作成功")
                  }else{
                    this.$message.error("操作失败：" + response.msg)
                  }
                }).complete(() => {
                  this.loading = false;
                })
            },
            querydata(){
              const params = {
                roleId: this.roleId
              };
              queryRoleFields(params).then(response => {
                if(response.data.authoritys !== null && response.data.authoritys.length !== 0){
                  this.radio = 1
                }else{
                  this.radio = 0
                }
                this.resourceId = response.data.list[0].id
              })
            }
        }
    }
</script>

<style scoped>

  .role-field-content {
    background: white;
    /* box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15); */
    font-size: 14px;
    color: #666;
    height: 100%
  }
  .field-row {
    padding: 12px 4px;
    border-bottom: 1px solid #e8e8e8;
  }
  .field-row-header{
    background-color: #F6F8FB;
  }
</style>
